import { Card, Stack, Text, styled } from '@/theme/index';

export const FixedText = styled(Text)({
  width: '49%',
  wordWrap: 'break-word',
});

export const CardContainer = styled(Card)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '48%',
  },
}));

export const CardContentContainer = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    height: '100%',
    justifyContent: 'space-between',
  },
}));

export const RowContainer = styled(Stack)({
  flexDirection: 'row',
});

export const CustomDivider = styled('div')({
  marginLeft: '12px',
  borderLeft: '2px solid #BDBDBD',
  borderBottom: '2px solid #BDBDBD',
  width: '26px',
  height: '27px',
  position: 'absolute',
  top: '-10px',
});
